import BigNumber from 'bignumber.js';
import { PersistedState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

type AccountTopUpPersistedState = Record<string, unknown>;

export const accountTopUpPersistConfig = {
  key: 'account/topUp',
  storage,
  migrate: (state: AccountTopUpPersistedState = {}) => {
    Object.keys(state).forEach(address => {
      const entry = state[address] as { amount?: BigNumber.Value } | undefined;

      state[address] =
        address === 'topUpOrigin'
          ? state[address]
          : {
              ...entry,
              amount: new BigNumber(entry?.amount || 0),
            };
    });

    return Promise.resolve(state as unknown as PersistedState);
  },
};
